import React from "react";
import styles from "./index.module.scss";
import classNames from "classnames/bind";
import { Fruit } from "../object/Fruit";

const cx = classNames.bind(styles);

interface HeaderProps {
  bestScore: number;
  score: number;
  nextItem: Fruit;
  onHomeClick: () => void;
}

const Header = ({ bestScore, score, nextItem, onHomeClick }: HeaderProps) => {
  return (
    <div className={cx("headerArea")}>
      <button className={cx("homeBtn")} onClick={onHomeClick}>
        HOME
      </button>

      <div className={cx("scoresContainer")}>
        <div className={cx("bestScoreArea")}>
          <div className={cx("text")}>BEST</div>
          <div className={cx("number")}>{bestScore}</div>
        </div>

        <div className={cx("scoreArea")}>
          <div className={cx("scoreTitle")}>SCORE</div>
          <div className={cx("scoreValue")}>{score}</div>
        </div>

        <div className={cx("nextArea")}>
          <div className={cx("nextTitle")}>NEXT</div>
          <div className={cx("nextValue")}>
            <img
              src={`/resource/${nextItem}.png`}
              alt={nextItem}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
